import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { envAwarePost } from "../../util/util";

export const getEventList = createAsyncThunk("getEventList", 
  async (payload) => await envAwarePost("api/events/api/",{
      action: "getEventList",
      ...payload,
  })
)

export const getEventDetails = createAsyncThunk(
  "getEventDetails",
  async (payload) => await envAwarePost("api/events/api/",{
      action: "getEventDetails",
      ...payload,
  })
);
export const changeEventCompleteStatus = createAsyncThunk(
  "changeEventCompleteStatus",
  async (payload) => envAwarePost("api/events/api/",{
      action: "updateEvent",
      ...payload,
  })
);
export const changeWorkoutResults = createAsyncThunk(
  "changeWorkoutResults",
  async (payload) => envAwarePost("api/events/api/",{
      action: "trackExerciseResults",
      ...payload,
  })
);
export const changeWorkoutComplete = createAsyncThunk(
  "changeWorkoutComplete",
  async (payload) => envAwarePost("api/events/api/",{
    action: "updateExerciseDetails",
    // ...payload,
    exercise_type: payload.type,
    item_id: payload.exercise_id,
    complete: payload.complete
  })
);

export const deleteEvents = createAsyncThunk(
  "deleteEvents",
  async (payload) => envAwarePost("api/events/api/",{
    action: "deleteEvents",
    ...payload,
  })
);

export const autoFillExerciseResults = createAsyncThunk(
  "autoFillExerciseResults",
  async (payload) => envAwarePost("api/events/api/",{
    action: "autoFillExerciseResults",
    exercise_id: payload.exercise_id,
    type: payload.type
  })
);

export const getEventComments = createAsyncThunk(
  "getEventComments",
  async (payload) => envAwarePost("addGetDBComments/",payload)
);
export const addCommentToEvent = createAsyncThunk(
  "addCommentToEvent",
  async (payload) => envAwarePost("addGetDBComments/",payload)
);
export const updateSimplifiedNutritionComplete = createAsyncThunk(
  "updateSimplifiedNutritionComplete",
  async (payload) => envAwarePost("api/events/api/",{
    action: "updateNutritionSimplifiedFood",
    id: payload.id,
    completed: payload.completed
  })
);
export const getClientData = createAsyncThunk(
  "getClientData",
  async (payload) => envAwarePost("clientListMobWeb/",payload)
);
export const getClientsList = createAsyncThunk(
  "getClientsList",
  async (payload) => envAwarePost("clientListMobWeb/",{
    includeFavorites: 0,
    includeAllClients: 0,
    includeDefaults: 0,
  })
);

export const copyEventToClients = createAsyncThunk(
  "copyEventToClients",
  async (payload) => envAwarePost( "api/events/api/",{
    action: "copyEventToOtherClients",
    ...payload
  })
);

export const addEventToFavorites = createAsyncThunk(
  "addEventToFavorites",
  async (payload) => envAwarePost("api/events/api/",{
    action: "addEventToFavorites",
    ...payload
  })
);

export const emailEventToClient = createAsyncThunk(
  "emailEventToClient",
  async (payload) => envAwarePost("emailEvent/",payload)
);

export const getAllEventsTemplates = createAsyncThunk(
  "getAllEventsTemplates",
  async () => envAwarePost("eventDetailsMobWeb/",{
    client_id: '99999999',
    display: 'all',
    eventType: 'workout',
    showEventDetails: 1
  })
);


const eventsSlice = createSlice({
  name: "events",
  initialState: {
    eventsList: [],
    eventsListStatus: "idle",
    eventDetails: {},
    eventDetailsStatus: "idle",
    eventComments: [],
    eventCommentsStatus: "idle",
    allEventsTemplates: [],
    eventsTemplatesStatus: "idle",
    deletingEventsStatus: "idle",
    clientData: {},
    clientsList: [],
    clientDataStatus: "idle",
    showAlertState: false,
    alertMsg: "",
    emailStatus: "idle"
  },
  reducers: {
    commentRead:(state,action)=>{
      const { payload } = action;
      let specifiedEvent = state.eventsList.find(
        (evt) => evt[`${payload.event_type}_id`] == payload.event_id
      );
      specifiedEvent.clientNewCommentFlag = 0;
    },
    setAlertStateToFalse: (state, action) => {
      state.showAlertState = false;
    }
  },
  extraReducers: {
    [getEventList.fulfilled]: (state, action) => {
      const { success, data } = action.payload;
      if (success == 0) {
        state.eventsListStatus = "failed";
      }else{
        state.eventsListStatus = "idle";
        state.eventsList = data.events.map(eventObj =>( {
          ...eventObj,
          details: {}
        }));
      }
    },
    [getEventList.pending]: (state, action) => {
      state.eventsListStatus = "fetching";
    },
    [getEventList.rejected]: (state, action) => {
      state.eventsListStatus = "failed";
    },
    [getEventDetails.fulfilled]: (state, action) => {
      const { success, data } = action.payload;
      if (success == 1) {
        state.eventDetails = data;
        let specificEvent = state.eventsList.find(event => event[`${action.meta.arg.event_type}_id`] == action.meta.arg.event_id);
        specificEvent.details = data;
        state.eventDetailsStatus = "idle";
      }
    },
    [getEventDetails.pending]: (state, action) => {
      state.eventDetailsStatus = "fetching";
    },
    [getEventDetails.rejected]: (state, action) => {
      state.eventDetailsStatus = "failed";
	},
	
	//I was previously changing the state after the request was fulfilled, but it was taking too long which caused the UI to be unresponsive. So now I'm changing the state in the pending state
    [changeEventCompleteStatus.pending]: (state, action) => {
      const { arg } = action.meta;
      let specifiedEvent = state.eventsList.find(
        (evt) => evt[`${arg.event_type}_id`] == arg.event_id
      );
      specifiedEvent.complete = arg.complete;
    },
    [changeEventCompleteStatus.fulfilled]: (state, action) => {
      const { arg } = action.meta;

	},
	

    [changeWorkoutComplete.pending]: (state, action) => {
      const { arg } = action.meta;
      // console.log(arg.details)
      let specificEvent = state.eventsList.find(event => event[`workout_id`] == action.meta.arg.details.workout_id);
      // console.log(JSON.stringify(specificEvent, undefined, 2));
      specificEvent.details.routine[arg.routineIndex].exercises[
        arg.exerciseIndex
      ].complete = arg.complete
    },
    [changeWorkoutComplete.fulfilled]: (state, action) => {
      const { arg } = action.meta;

	},
	

    [autoFillExerciseResults.fulfilled]: (state, action) => {
      const { arg } = action.meta;
      state.eventDetailsStatus = "idle";
      let specificEvent = state.eventsList.find(event => event[`workout_id`] == action.meta.arg.details.workout_id);
      console.log(JSON.stringify(specificEvent, undefined, 2));
      specificEvent.details.routine[arg.routineIndex].exercises[
        arg.exerciseIndex
      ] = {...action.payload.data, complete: 1, demo_link: action.payload.data.link}
    },
    [getEventComments.pending]: (state, action) => {
      state.eventCommentsStatus = "fetching";
    },
    [getEventComments.fulfilled]: (state, action) => {
      state.eventCommentsStatus = "idle";
      state.eventComments = action.payload.data;
    },
    [getEventComments.rejected]: (state, action) => {
      state.eventCommentsStatus = "failed";

    },
    [addCommentToEvent.fulfilled]: (state, action) => {
      state.eventComments.unshift(action.payload.data);
    },
    [updateSimplifiedNutritionComplete.pending]: (state, action) => {
      let specificEvent = state.eventsList.find(event => event[`nutrition_id`] == action.meta.arg.event.nutrition_id);
      console.log(JSON.stringify(specificEvent, undefined, 2))
      specificEvent.details.food.find(
        (foodItem) => foodItem.id == action.meta.arg.id
      ).completed = action.meta.arg.completed;
    },
    [updateSimplifiedNutritionComplete.fulfilled]: (state, action) => {
      let specificEvent = state.eventsList.find(event => event[`nutrition_id`] == action.meta.arg.event.nutrition_id);
      specificEvent.details.food.find(
        (foodItem) => foodItem.id == action.meta.arg.id
      ).completed = action.meta.arg.completed;
    },

    [getAllEventsTemplates.pending]: (state, action) => {
      state.eventsTemplatesStatus = "fetching"
    },

    [getAllEventsTemplates.fulfilled]: (state, action) => {
      state.eventsTemplatesStatus = "idle"
      state.allEventsTemplates = action.payload.data
    },
    [deleteEvents.fulfilled] : (state, action) => {
      const deletedEvents = action.payload.data;
      const eventType = action.meta.arg.event_type;
      state.deletingEventsStatus = "idle"
      state.eventsList = state.eventsList.filter(event => !deletedEvents.includes(event[`${eventType}_id`].toString()))

    },
    [deleteEvents.pending] : (state, action) => {
      state.deletingEventsStatus = "fetching"

    },
    [getClientData.pending]: (state, action) => {
        state.clientDataStatus = "fetching"
    },
    [getClientData.fulfilled]: (state, action) => {
        state.clientDataStatus = "idle"
        state.clientData = action.payload.data[0]
    },
    [getClientsList.fulfilled]: (state, action) => {
        console.log(action.payload)
        state.clientsList = action.payload.data
    },
    [copyEventToClients.pending]: (state, action)=>  {
      state.showAlertState = false
    },
    [copyEventToClients.fulfilled]: (state, action)=>  {
      const {success} = action.payload
      if(parseInt(success)===1){
        state.alertMsg = action.payload.message ? action.payload.message : "The event was copied successfully"
        state.showAlertState = true
        if(action.meta.arg.return_first_created == 1){
          state.eventsList.unshift({...action.payload.data, details: {}});
        }
      }
    },
    [addEventToFavorites.pending]: (state, action)=>  {
      state.showAlertState = false
    },
    [addEventToFavorites.fulfilled]: (state, action)=>  {
      state.alertMsg =  action.payload.message ? action.payload.message : "The event was added to your favorites successfully"
      state.showAlertState = true
    },
    [emailEventToClient.pending]: (state, action)=>  {
      state.showAlertState = false;
      state.emailStatus = "fetching"

    },
    [changeWorkoutResults.fulfilled]: (state, action)=>  {
      console.log(action);

    },
    // [emailEventToClient.fulfilled]: (state, action)=>  {
    //   state.alertMsg =  action.payload.message ? action.payload.message : "The event was emailed to the client successfully"
    //   state.showAlertState = true
    // },
    //The request fails on new even when the email is sent successfully. So showing alert here event for a rejected event
    [emailEventToClient.rejected]: (state, action)=>  {
      state.alertMsg =   "The event was emailed to the client successfully"
      state.showAlertState = true;
      state.emailStatus = "idle"

    },
  },
});

export const {commentRead, setAlertStateToFalse} = eventsSlice.actions

export default eventsSlice.reducer;
